<button type="button" class="btn btn-sm si-book" [class]="buttonClass" [disabled]="busy" (click)="book()">
  <i [class]="icon"></i>{{ labelKey | translate }}
</button>
